import { render, staticRenderFns } from "./dormList.vue?vue&type=template&id=00ef11be&scoped=true"
import script from "./dormList.vue?vue&type=script&lang=js"
export * from "./dormList.vue?vue&type=script&lang=js"
import style0 from "./dormList.vue?vue&type=style&index=0&id=00ef11be&prod&scoped=true&lang=css"
import style1 from "./dormList.vue?vue&type=style&index=1&id=00ef11be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef11be",
  null
  
)

export default component.exports